<template>
    <admin-breadcrumbs>
         <li class="breadcrumb-item">
            <router-link to="/admin/users/">
                Users
            </router-link>
        </li>

        <li class="breadcrumb-item active">
            Edit User
        </li>
    </admin-breadcrumbs>

    <div class="card card-default">

        <div class="card-header">
            Edit User
        </div>

        <div class="card-body">
           <user-edit-form
               :endpoint="`/admin/api/users/${$route.params.id}`"
               method="put"
           />
        </div>

    </div>


    <div class="card card-default">

        <div class="card-header">
            Impersonate
        </div>

        <div class="card-body">
            <a
                :href="`/impersonate/take/${$route.params.id}`"
                class="btn btn-primary btn-sm"
            >
                Impersonate
            </a>
        </div>

    </div>


    <div class="card card-default">

        <div class="card-header">
            Usage
        </div>

        <div class="card-body">

            <p>
                <strong>Subscribed</strong>:
                {{ usage.isSubscribed || false }}
            </p>

            <p>
                <strong>Trial</strong>:
                {{ usage.onTrial || false }}
            </p>

            <p>
                <strong>Generic trial</strong>:
                {{ usage.onGenericTrial || false }}
            </p>

            <p>
                <strong>Has expired trial</strong>:
                {{ usage.hasExpiredTrial || false }}
            </p>

            <p v-if="usage.subscription?.stripe_id">
                <strong>Stripe ID</strong>:
                {{ usage.subscription.stripe_id }}
            </p>

            <p v-if="usage.subscription?.stripe_price">
                <strong>Stripe Plan</strong>:
                {{ usage.subscription.stripe_price }}
            </p>

            <hr />

            <p>
                <strong>Lessons shared/viewed</strong>:
                {{ usage.lessonViewCount }}
                <span class="text-muted">(limit is {{ usage.lessonViewLimit }})</span>
            </p>

            <p>
                <strong>Lessons where media was downloaded</strong>:
                {{ usage.mediaLessonViewCount }}
                <span class="text-muted">(limit is {{ usage.monthlyMediaDownloadLimit }})</span>
            </p>

            <p class="mb-0">
                <strong>Media downloaded</strong>:
                {{ usage.mediaViewCount }}
            </p>

        </div>

    </div>

    <div class="card card-default">

        <div class="card-header">
            Lessons shared/viewed log <em class="text-muted">(past {{ $app.monthDurationDays }} days)</em>
        </div>

        <div class="card-body">

            <table class="table">

                <thead>
                    <tr>
                        <th>
                            Lesson
                        </th>
                        <th>
                            Series
                        </th>
                        <th>
                            Logged in?
                        </th>
                        <th>
                            Date viewed
                        </th>
                    </tr>
                </thead>

                <tbody>

                    <template v-if="(usage.lessonViews && usage.lessonViews.length)">
                        <tr v-for="row in usage.lessonViews">
                            <td>
                                {{ row.lesson.title }}
                                <span class="text-muted">
                                    [<a :href="`/admin/lessons/${row.lesson.id}/edit/`">#{{ row.lesson.id }}</a>]
                                </span>
                            </td>
                            <td>
                                {{ row.lesson.series.title }}
                                <span class="text-muted">
                                    [<a :href="`/admin/series/${row.lesson.series.id}/edit/`">#{{row.lesson.series.id}}</a>]
                                </span>
                            </td>
                            <td>
                                {{ (row.is_auth ? 'Yes' : 'No') }}
                            </td>
                            <td>
                                {{ row.created_at }}
                            </td>
                        </tr>
                    </template>

                    <tr v-else>
                        <td colspan="4">
                            No rows found
                        </td>
                    </tr>

                </tbody>

            </table>

        </div>

    </div>

    <div class="card card-default">

        <div class="card-header">
            Media downloaded log <em class="text-muted">(past {{ $app.monthDurationDays }} days)</em>
        </div>

        <div class="card-body">

            <table class="table">

                <thead>
                    <tr>
                        <th>
                            Media
                        </th>
                        <th>
                            Lesson
                        </th>
                        <th>
                            Logged in?
                        </th>
                        <th>
                            Date downloaded
                        </th>
                    </tr>
                </thead>

                <tbody>

                <template v-if="(usage.mediaViews && usage.mediaViews.length)">

                    <tr v-for="row in usage.mediaViews">
                        <td>
                            {{ row.media.name }}
                            <span class="text-muted">
                                [<a :href="`/admin/media/${row.media.id}/edit/`">#{{ row.media.id }}</a>]
                            </span>
                        </td>

                        <td>
                            {{ row.lesson.title }}
                            <span class="text-muted">
                                [<a :href="`/admin/lessons/${row.lesson.id}/edit/`">#{{ row.lesson.id }}</a>]
                            </span>
                        </td>

                        <td>
                            {{ (row.is_auth ? 'Yes' : 'No') }}
                        </td>

                        <td>
                            {{ row.created_at }}
                        </td>
                    </tr>
                </template>

                <tr v-else>
                    <td colspan="4">
                        No rows found
                    </td>
                </tr>

                </tbody>

            </table>

        </div>

    </div>
</template>

<script>
import UserEditForm from "../../../admin/UserEditForm.vue";
import AdminBreadcrumbs from "../../../partials/AdminBreadcrumbs.vue";

export default {
    name: "UserEdit",

    components: {
        AdminBreadcrumbs,
        UserEditForm,
    },

    data() {
        return {
            usage: {},
        };
    },

    mounted() {
        axios.get(`/admin/api/users/${this.$route.params.id}/usage`)
            .then((response) => {
                this.usage = response.data;
            });
    },
};
</script>
